import {create} from "zustand";
import { 
    IAdoptEaseConfig,
    IAdoptEaseUsage,
    IAdoptEaseWorkflow,
    INeverUsedApp } from '../../types';
import { IAdoptEaseCampaign } from './AdoptEaseCampaignInterface';

export interface AdoptEaseState {
    adoptEaseDefaultConfigData: IAdoptEaseConfig[];
    setAdoptEaseDefaultConfigData: (adoptEaseDefaultConfigData:IAdoptEaseConfig[]) => void;
    adoptEaseUsageData: IAdoptEaseUsage[];
    setAdoptEaseUsageData: (adoptEaseUsageData:IAdoptEaseUsage[]) => void;
    adoptEaseWorkflows: IAdoptEaseWorkflow[];
    setIAdoptEaseWorkflows: (adoptEaseWorkflows:IAdoptEaseWorkflow[]) => void;
    neverUsedApps: INeverUsedApp[];
    setNeverUsedApps: (neverUsedApps: INeverUsedApp[]) => void;
    adoptEaseApps: any[];
    setAdoptEaseApps:(adoptEaseApps:any[]) => void;
    filteredAdoptEaseWorkflows: any[];
    setFilteredAdoptEaseWorkflows:(filteredAdoptEaseWorkflows:any[]) => void;
    adoptEaseCampaigns: IAdoptEaseCampaign[];
    setAdoptEaseCampaigns:(adoptEaseCampaigns:IAdoptEaseCampaign[]) => void;
  }
  
export const useAdoptEaseStore = create<AdoptEaseState>((set) => ({

    adoptEaseUsageData: [],
    setAdoptEaseUsageData: (adoptEaseUsageData) => set(() => ({ adoptEaseUsageData })),

    adoptEaseDefaultConfigData: [],
    setAdoptEaseDefaultConfigData: (adoptEaseDefaultConfigData) => set(() => ({ adoptEaseDefaultConfigData })),

    adoptEaseWorkflows: [],
    setIAdoptEaseWorkflows: (adoptEaseWorkflows) => set(() => ({ adoptEaseWorkflows })),

    filteredAdoptEaseWorkflows: [],
    setFilteredAdoptEaseWorkflows: (filteredAdoptEaseWorkflows) => set(() => ({ filteredAdoptEaseWorkflows })),

    neverUsedApps: [],
    setNeverUsedApps: (neverUsedApps) => set(() => ({ neverUsedApps })),

    adoptEaseApps:[],
    setAdoptEaseApps: (adoptEaseApps) => set(() => ({ adoptEaseApps })),

    adoptEaseCampaigns: [],
    setAdoptEaseCampaigns: (adoptEaseCampaigns) => set(() => ({ adoptEaseCampaigns })),

 }));

    


